import React from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';

export default class Pagination extends React.Component {
  render() {
    const {current, count, limit, handle} = this.props
    let total_page = Math.ceil(count / limit)
    let current_normalize = current - 1
    if(count < limit || count === 0) return null


    const DISABLED = (this.props.isLoading)? ' disabled' : ''
    return (
      <div className="pagination-flexcenter" >
        <ReactPaginate
          previousLabel         ={"previous"}
          previousLinkClassName ={'noselect'}
          nextLabel             ={"next"}
          nextLinkClassName     ={'noselect'}
          breakLabel            ={<a onClick={(e)=>e.stopPropagation()} style={{color: '#20a8d8', cursor: 'pointer'}}>...</a>}
          breakClassName        ={"break-me"}
          pageCount             ={total_page}
          forcePage             ={current_normalize}
          marginPagesDisplayed  ={2}
          pageRangeDisplayed    ={5}
          onPageChange          ={handle}
          containerClassName    ={"pagination"}
          subContainerClassName ={"pages pagination"}
          activeClassName       ={"active"}
          pageClassName         ={'noselect'+DISABLED} 
          nextClassName         ={DISABLED}
          previousClassName     ={DISABLED}  
        />
      </div>
    );
  }
}

Pagination.propTypes = {
  current    : PropTypes.number.isRequired,
  count      : PropTypes.number.isRequired,
  limit      : PropTypes.number.isRequired,
  handle     : PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/App/component/Pagination.js